import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function NearbyIntro() {
  return (
    <section
      id="overview"
      aria-labelledby="nearby-intro-heading"
      className="bg-background py-16 md:py-24"
    >
      <div className="shell">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-10">
          <Reveal className="relative lg:col-span-6" y={40}>
            <img
              src={images.advEscape}
              alt="American River canyon adventure near Auburn RV Resort"
              width={1400}
              height={1600}
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover"
            />
          </Reveal>

          <div className="lg:col-span-6 lg:pl-8">
            <Reveal>
              <Eyebrow>Your Base Camp for More</Eyebrow>
            </Reveal>
            <h2 id="nearby-intro-heading" className="display-lg mt-6 max-w-[14ch]">
              <MaskReveal>Stay Here.</MaskReveal>
              <MaskReveal delay={0.08}>Explore Everywhere.</MaskReveal>
            </h2>
            <Reveal delay={0.12}>
              <div className="mt-8 space-y-5 text-base leading-relaxed text-muted-foreground md:text-[1.05rem]">
                <p>
                  Auburn RV Resort puts guests near a remarkable mix of outdoor recreation,
                  California history, local food and drink, historic communities and scenic mountain
                  destinations.
                </p>
                <p>
                  Whether your perfect day means hiking beside the American River, riding mountain
                  trails, learning about California&apos;s Gold Rush, visiting local wineries or
                  heading into the mountains, there is always another adventure waiting beyond your
                  RV site.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.18}>
              <ResortLink variant="gold" href="/reservations/" className="mt-10 w-full sm:w-auto">
                Check Availability
              </ResortLink>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
